var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "file-record",
      class: [_vm.type],
      on: { click: _vm.download }
    },
    [
      _c("div", { staticClass: "file-record-content" }, [
        _c("div", { staticClass: "file-record-title" }, [
          _vm._v(_vm._s(_vm.title || _vm.fileName(_vm.url)))
        ]),
        _c("div", { staticClass: "file-record-size" }, [
          _vm._v(_vm._s(_vm.size))
        ])
      ]),
      _c("div", { staticClass: "file-record-img" }, [
        _c("img", { attrs: { src: _vm.fileIcon(_vm.fileType) } })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }